import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            深度专题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            焦点推荐
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            深度解读热门剧集，从角色、剧情到制作，吃瓜视频带你读懂每一部好剧
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 吃瓜视频焦点专题`}
                  title={`${item.title} - 热门剧集完整版在线看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-xs bg-white/90 backdrop-blur-sm text-foreground-800 font-medium px-2.5 py-1 rounded-full">
                    {item.category}
                  </span>
                </div>
                <div className="absolute top-3 right-4">
                  <span className="text-xs bg-accent-500 text-white font-semibold px-3 py-1 rounded-full">
                    {item.highlight}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}